module.exports = __webpack_public_path__ + "static/money-d72a36832dd63694341e16220942a653.svg";